export default "/images/eurodom.png?2dcd75fc61c4a318357c73ca1043cb23";